import React from "react";

import FilePlus from "../../../utils/icons/FilePlus";

export default function OpSimple({
  valid,
  labelButton,
  message,
  onSubmit,
}: {
  valid: boolean;
  labelButton?: string;
  message: string;
  onSubmit: Function;
}) {
  return valid ? (
    <>
      <div className="center mt1">
        <button className="secondary" onClick={() => onSubmit({})}>
          {labelButton}
        </button>
      </div>
    </>
  ) : (
    <p className="mb1 mt1 tac fz08 with-icon">
      <FilePlus size={16} className="ib" /> {message}
    </p>
  );
}
